import {SvgIcon} from "@mui/material"
import React from "react"

const iconMap= {
    Download: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 18.67V0.5"
                strokeWidth="1.5"
                stroke="currentColor"
                strokeMiterlimit="10"
            />
            <path
                d="M4.35001 11.02L12 18.67L19.65 11.02"
                strokeWidth="1.5"
                stroke="currentColor"
                strokeMiterlimit="10"
            />
            <path
                d="M4.35001 22.5H19.65"
                strokeWidth="1.5"
                stroke="currentColor"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    Cross: (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.820007 0.820007L7.18001 7.18001"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M7.18001 0.820007L0.820007 7.18001"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    Check: (
        <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.17999 4L3.72666 6.54667L8.81999 1.45334"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    Attention: (
        <svg
            width="2"
            height="8"
            viewBox="0 0 2 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.515 4.9V-4.76837e-07H1.67V4.9H0.515ZM1.1 7.13C0.903333 7.13 0.736667
                     7.06167 0.6 6.925C0.466667 6.78833 0.4 6.62167 0.4 6.425C0.4 6.23167 0.466667 
                    6.06833 0.6 5.935C0.736667 5.80167 0.903333 5.735 1.1 5.735C1.29 5.735 1.45167
                     5.80167 1.585 5.935C1.71833 6.06833 1.785 6.23167 1.785 6.425C1.785 6.62167 1.71833 6.78833
                    1.585 6.925C1.45167 7.06167 1.29 7.13 1.1 7.13Z"
                fill="currentColor"
            />
        </svg>
    ),
    Info: (
        <svg
            width="2"
            height="8"
            viewBox="0 0 2 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.485 3.1L1.485 8H0.33L0.33 3.1H1.485ZM0.9 0.87C1.09667 0.87 1.26333 0.938333
                     1.4 1.075C1.53333 1.21167 1.6 1.37833 1.6 1.575C1.6 1.76833 1.53333 1.93167 1.4 
                     2.065C1.26333 2.19833 1.09667 2.265 0.9 2.265C0.71 2.265 0.548333 2.19833 0.415 
                     2.065C0.281667 1.93167 0.215 1.76833 0.215 1.575C0.215 1.37833 0.281667 1.21167 
                     0.415 1.075C0.548333 0.938333 0.71 0.87 0.9 0.87Z"
                fill="currentColor"
            />
        </svg>
    ),
    SmallCross: (
        <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.27002 4.99999L5.09002 8.81999L12.73 1.17999"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    DropdownInfo: (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_219_6094)">
                <path
                    d="M24 34.5C29.799 34.5 34.5 29.799 34.5 24C34.5
                     18.201 29.799 13.5 24 13.5C18.201 13.5 13.5 18.201
                     13.5 24C13.5 29.799 18.201 34.5 24 34.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M24 28.77V22.09H22.09"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.09 28.77H25.91"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M23.05 19.23H24.95"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_219_6094">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(12 12)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    Calendar: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_69_2110)">
                <path
                    d="M22.52 3.37H1.47998V8.14999H22.52V3.37Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.52 8.15002H1.47998V22.5H22.52V8.15002Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M5.30005 12.93H7.22005"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M9.13 12.93H11.04"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M12.96 12.93H14.87"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M16.78 12.93H18.7"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M16.78 17.72H18.7"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M5.30005 17.72H7.22005"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M9.13 17.72H11.04"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M12.96 17.72H14.87"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M6.26001 0.5V5.28"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M12 0.5V5.28"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M17.74 0.5V5.28"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_69_2110">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    Forbidden: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1133_29761)">
                <path
                    d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5
                     6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101
                      1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M19.64 4.35999L4.35999 19.64"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_1133_29761">
                    <rect
                        width="24"
                        height="24"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    Search: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_69_2098)">
                <path
                    d="M9.14 16.78C13.3595 16.78 16.78 13.3595
                     16.78 9.14C16.78 4.92054 13.3595 1.5 9.14
                      1.5C4.92054 1.5 1.5 4.92054 1.5 9.14C1.5
                       13.3595 4.92054 16.78 9.14 16.78Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.5 22.5L14.39 14.39"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_69_2098">
                    <rect
                        width="24"
                        height="24"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    CircleCheck: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_69_2111)">
                <path
                    d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5
                     6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101
                      1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M6.27002 12L10.09 15.82L17.73 8.17999"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_69_2111">
                    <rect
                        width="24"
                        height="24"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    CircleStop: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_69_2112)">
                <path
                    d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101
                     17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799
                      6.20101 22.5 12 22.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M6.27002 12H17.73"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_69_2112">
                    <rect
                        width="24"
                        height="24"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    Euro: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.59 16.77C20.5913 17.5229 20.444 18.2686
                 20.1565 18.9643C19.869 19.6601 19.447 20.2923 
                 18.9147 20.8247C18.3823 21.357 17.7501 21.779 
                 17.0544 22.0665C16.3586 22.354 15.6129 22.5013 
                 14.86 22.5H12C10.4803 22.5 9.02288 21.8963 7.9483 
                 20.8217C6.87371 19.7471 6.27002 18.2897 6.27002 
                 16.77V7.23001C6.27002 5.71032 6.87371 4.25287 7.9483
                  3.17829C9.02288 2.1037 10.4803 1.50001 12 1.50001H14.86C15.6129 
                  1.49869 16.3586 1.646 17.0544 1.9335C17.7501 2.22099
                   18.3823 2.64301 18.9147 3.17535C19.447 3.70769 19.869 
                   4.33988 20.1565 5.03568C20.444 5.73147 20.5913 6.47716
                    20.59 7.23001"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M3.41003 9.14001H10.09"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M3.41003 14.86H10.09"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
        </svg>
    ),
    Percent: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 5L5 19M9 6.5C9 7.88071 7.88071 9 6.5 9C5.11929
                 9 4 7.88071 4 6.5C4 5.11929 5.11929 4 6.5 4C7.88071
                  4 9 5.11929 9 6.5ZM20 17.5C20 18.8807 18.8807 20
                   17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193
                    16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                stroke-linejoin="round"
            />
        </svg>
    ),
    ChevronDown: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    InfoOutlined: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_787_3927)">
                <path
                    d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M12.0001 16.77V10.09H10.0901"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M10.0901 16.77H13.9101"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M11.05 7.22998H12.95"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_787_3927">
                    <rect
                        width="24"
                        height="24"
                        fill="transparent"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    ProhibitedOutlined: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_787_3921)">
                <path
                    d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                />
                <path
                    d="M19.6401 4.35999L4.36011 19.64"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_787_3921">
                    <rect
                        width="24"
                        height="24"
                        fill="transparent"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
}


const Icon = ({
    color = "#fff",
    size = "small",
    iconName,
    className,
}) => {
    return (
        <SvgIcon
            className={className}
            htmlColor={color}
            fontSize={size}>
            {iconMap[iconName]}
        </SvgIcon>
    )
}

export default Icon
